// extracted by mini-css-extract-plugin
module.exports = {"box":"email_box___y0Ta"};